import * as React from 'react'
import {
  Box,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

// Replica la estructura visual de ListItemRow: label fijo a la izquierda, skeleton a la derecha
const SkelRow = ({ label, width = '50%' }) => (
  <Box
    sx={{
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      minHeight: 24,
      py: '2px',
    }}>
    <Box
      sx={{
        width,
        flexShrink: 0,
        fontSize: 13,
        color: '#6A6A6A',
        fontFamily: 'inherit',
        lineHeight: 1,
      }}>
      {label}:
    </Box>
    <Box sx={{ flexGrow: 1 }}>
      <Skeleton variant="text" height={16} />
    </Box>
  </Box>
)

const SectionTitle = ({ children }) => (
  <Typography
    sx={{
      fontFamily: 'inherit',
      fontSize: '0.8em',
      fontWeight: 600,
      lineHeight: 1,
      color: '#1B1C37',
    }}>
    {children}
  </Typography>
)

export default function DrawerSkeleton() {
  return (
    <Box sx={{ px: 2, pt: 1.5, pb: 2 }}>
      {/* Galería de fotos */}
      <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 1, mb: 1.5 }} />

      {/* UBICACIÓN DEL ÁRBOL — cerrado por defecto */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <SectionTitle>UBICACIÓN DEL ÁRBOL</SectionTitle>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 1 }}>
          <List sx={{ py: 0 }}>
            <SkelRow label="Sitio" width="25%" />
            <SkelRow label="Parroquia" width="25%" />
            <SkelRow label="Sección" width="25%" />
          </List>
          {/* Coordenadas en grid 2 cols */}
          <Box sx={{ py: 1 }}>
            <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={1}>
              <Skeleton variant="rounded" height={20} />
              <Skeleton variant="rounded" height={20} />
              <Skeleton variant="rounded" height={20} />
              <Skeleton variant="rounded" height={20} />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* SERVICIOS ECOSISTÉMICOS — abierto por defecto */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <SectionTitle>SERVICIOS ECOSISTÉMICOS</SectionTitle>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 1 }}>
          <List sx={{ py: 0 }}>
            <SkelRow label="Biomasa" width="25%" />
            <SkelRow label="Carbono" width="25%" />
            <SkelRow label="Oxígeno" width="25%" />
          </List>
        </AccordionDetails>
      </Accordion>

      {/* DESCRIPCIÓN GENERAL — abierto por defecto */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <SectionTitle>DESCRIPCIÓN GENERAL</SectionTitle>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 1 }}>
          <List sx={{ py: 0 }}>
            <SkelRow label="Nombre común" />
            <SkelRow label="Nombre científico" />
            <SkelRow label="Familia" />
          </List>
          {/* Grid 2 cols para atributos numéricos (DAP, HT, etc.) */}
          <Box sx={{ py: 1 }}>
            <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={1}>
              {[...Array(6)].map((_, i) => (
                <Skeleton key={i} variant="rounded" height={20} />
              ))}
            </Box>
          </Box>
          <List sx={{ py: 0 }}>
            <SkelRow label="Estado actual" />
            <SkelRow label="Código" />
          </List>
        </AccordionDetails>
      </Accordion>

      {/* INFORMACIÓN DEL REGISTRO — cerrado por defecto */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <SectionTitle>INFORMACIÓN DEL REGISTRO</SectionTitle>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 1 }}>
          <List sx={{ py: 0 }}>
            <SkelRow label="Nombre del colector" />
            <SkelRow label="Fecha de registro" />
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
